import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("ccc_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const peso = (n) =>
  `₱${Number(n || 0).toLocaleString("en-PH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const pesoShort = (n) =>
  `₱${Number(n || 0).toLocaleString("en-PH", { maximumFractionDigits: 0 })}`;

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}

export const STATUS_STEPS = [
  "waiting", "bay_assigned", "washing", "drying", "quality_check", "ready", "released",
];

export const STATUS_META = {
  waiting: { label: "Waiting", cls: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  bay_assigned: { label: "Bay Assigned", cls: "bg-indigo-500/10 text-indigo-400 border-indigo-500/30" },
  washing: { label: "Washing", cls: "bg-cyan-500/10 text-cyan-400 border-cyan-500/30" },
  drying: { label: "Drying", cls: "bg-blue-500/10 text-blue-400 border-blue-500/30" },
  quality_check: { label: "Quality Check", cls: "bg-purple-500/10 text-purple-400 border-purple-500/30" },
  ready: { label: "Ready", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  released: { label: "Released", cls: "bg-slate-500/10 text-slate-400 border-slate-500/30" },
};

export function fmtElapsed(fromIso, toIso) {
  if (!fromIso) return "0:00";
  const start = new Date(fromIso).getTime();
  const end = toIso ? new Date(toIso).getTime() : Date.now();
  let s = Math.max(0, Math.floor((end - start) / 1000));
  const h = Math.floor(s / 3600); s -= h * 3600;
  const m = Math.floor(s / 60); s -= m * 60;
  const mm = String(m).padStart(2, "0");
  const ss = String(s).padStart(2, "0");
  return h > 0 ? `${h}:${mm}:${ss}` : `${m}:${ss}`;
}
